/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeys } from '../../models/api-keys';

export interface ApiKeysGetAllKeys$Params {
}

export function apiKeysGetAllKeys(http: HttpClient, rootUrl: string, params?: ApiKeysGetAllKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiKeys>>> {
  const rb = new RequestBuilder(rootUrl, apiKeysGetAllKeys.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApiKeys>>;
    })
  );
}

apiKeysGetAllKeys.PATH = '/api/ApiKeys';
